import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ReportStoreEffects } from './effects';
import { ReportReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('Report', ReportReducer), EffectsModule.forFeature([ReportStoreEffects])],
  providers: [ReportStoreEffects],
})
export class ReportStoreModule {}
